const URL = {
    // 交易系统
    // "JYXT": "http://jyzx.yunfu.gov.cn/login",
   "JYXT": "https://ygp.gdzwfw.gov.cn/ggzy-yhzx/",
    // 网上办事
    "WSBS": "https://wsbs.yf.gov.cn/",
    // 政声传递
    "ZSCD": "http://www.gd.gov.cn/xxts/",
    // 中介服务超市
    "ZJFWCS": "https://zjcs.yf.gov.cn/portal/zjcs/index.action",
    // 全国公共资源交易平台
    "QGGGZYJYPT": "http://www.ggzy.gov.cn/",
    // 广东省公共资源交易中心
    "GDSGGZYJYZX": "http://ggzy.gd.gov.cn/",
    // 云浮市人民政府
    "SGSRMZF": "https://www.yf.gov.cn/",
    // 广州产权交易所云浮分所
    "GZCQJYSSGFS": "http://sg.gemas.com.cn",

    // 市直属部门网站
    // 云浮市发展和改革局
    "SGSFZHGGJ": "http://fgj.yf.gov.cn",
    // 云浮市住房和城乡建设局
    "SGSZFHCXJSJ": "http://zgj.yf.gov.cn/",
    // 云浮市水务局
    "SGSSWJ": "http://water.yf.gov.cn/",
    // 云浮市交通运输局
    "SGSJTYSJ": "https://www.yf.gov.cn/bmpdlm/sgsjtysj/tzgg/",

    //国土资源交易过程信息
    "GTZYJYGCXX": "/gtzyjygcxx/",
    // 河砂权交易过程信息
    "HSQJYGCXX": "/hsqjygcxx/",
    // 河砂权 专家评审
    "HSQZJPS": "http://hsjy.jyzx.yf.gov.cn/expertlogin",
    // 产权挂牌/拍卖过程信息
    "CQGPGCXX": "/cqjygcxx/cqgp",
    // 产权招标过程信息
    "CQZBGCXX": "/cqjygcxx/cqzb",

    "API": process.env.VUE_APP_API_URL,

    "BTN_WSBJ":"http://www.cyberpolice.cn/wfjb/",
    "BTN_AW":"http://gdga.gd.gov.cn/",
    "BTN_SYDW":"http://bszs.conac.cn/sitename?method=show&id=26EB00B541437B46E053022819AC3204",
    "BTN_BA":"https://beian.miit.gov.cn/#/Integrated/index",
    "WSBSDT":"http://jyzx.yf.gov.cn/sgbst/page/frontBstIndex.html",
    "BTN_BA2":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=",

    "BASE_URL": process.env.BASE_URL,

    "JJDT": "/gtzyjygcxx/zzgp",

    "FILE": process.env.VUE_APP_API_URL.replace('portal', '') + "api/stamperAddress/",

    "OLD_HOME": "https://ytk.swggzy.cn:8010/swsy/#/index/indexPage"
};

export default URL;
